import React from 'react'
// import get from 'lodash/get'
import TagManager from 'react-gtm-module'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { Button, Nav, Form, Row, Col, Modal, ModalTitle } from 'react-bootstrap'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import { IoIosInformationCircle as InformationIcon } from 'react-icons/io'
import {
  LinkWithLocale,
  SubscriptionDropDown,
  CustomPrice,
} from 'src/views/components'
import { pageNames } from 'src/routes/pathParams'
import { imagePlaceholder } from 'src/static/fixtures/imagePlaceholder'
import {
  cartContainer,
  customerContainer,
  subscriptionContainer,
  catalogContainer,
} from 'src/models'
import { Icons, ConfirmationModal, ImageComponent } from 'src/views/components'
import AccordionBlock from '../AccordionBlock'
import {
  convertToBoolean,
  getImageFromProperty,
  IS_BROWSER,
  isEligibleToShowPVCVSV,
  i18nTranslate,
} from 'src/utils'
import PriceSubscription from '../Price/PriceSubscription'
import CartScanCard from 'src/views/components/CartBlock/CartScanCard/CartScanCard'
import SubscriptionQuantityDropdown from '../QuantityDropdown/SubscriptionQuantityDropdown'
import { getScanQualifiedCountSumForBundleSubItems } from 'src/deps'
import SingleProductSubscriptionModal from 'src/views/components/SubscriptionComponents/SingleProductSubscriptionModal'
import './styles.scss'

@observer
class SubscriptionProductTile extends React.Component {
  @observable enableConfirmation = false
  @observable skipConfirmation = false
  @observable cancelConfirmation = false
  @observable isSkippedSubscription = false
  @observable isSkipCallInProgress = false
  @observable isDeleteCallInProgress = false
  @observable removeItemSubscription = false
  @observable scanCardShow = false
  @observable scanCardProductDetails = {}
  @observable bundleScan = false
  @observable bundleScanCount = 0
  @observable isSubscriptionPage = false
  @observable showSingleProductModal = false
  @observable productType = false
  selectedProductDetails = {}
  @observable isInfoModalEnabled = false
  // @observable disableNonActiveMonth =
  //   get(this.props, 'selectedMonth', 0) !==
  //   get(this.props, 'lastOrderProcessedMonth', 0) + 1
  // this will be an issue
  // if lastOrderProcessedMonth is nov ( two month once)
  // no order in dec
  // selected month = jan

  @observable disableNonActiveMonth = this.props.disableNonActiveMonth || false
  // selected month == current calendar month ?
  //  month_of_lastorderprocessingdate != current calendar month :
  //  selectedMonth == (current calendar month + 1) &&  month_of_lastorderprocessingdate == current calendar month

  // since disableNonActiveMonth depends on props, initializing it as a class field will not update the value on re-rendering
  // hence if previous props and the current props mismatch, disableNonActiveMonth is reassigned with new value

  constructor(props) {
    super(props)
    if (IS_BROWSER) {
      // To show modal for otp to sub
      this.isSubscriptionPage = window?.location?.pathname?.includes(
        pageNames?.myaccountsubscriptions
      )
    }
  }

  componentDidUpdate(prevProps) {
    const currentProps = this.props
    if (
      prevProps.disableNonActiveMonth !== currentProps.disableNonActiveMonth
    ) {
      this.disableNonActiveMonth = currentProps.disableNonActiveMonth
    }
  }

  // Frequency change also handles conversion of otp to sub and quantity change
  handleFrequencyChange = async (
    quantity,
    itemId,
    subscriptionReq,
    isOnetime = false,
    convertToSub = false
  ) => {
    // If the frequency is otp and conversion to sub -> show modal
    if (this.props?.data?.type === 'VARIABLE_SINGLE_ORDER' && !convertToSub) {
      this.openSingleSubscribeProductModal(subscriptionReq?.subscription)
    } else {
      const { handleFrequencyChange = {}, data = {} } = this.props
      const { subscription = {} } = subscriptionReq
      const { frequencyPeriod = 1, frequencyType = '' } = subscription
      const value = [frequencyPeriod, frequencyType].join('-')
      return (
        handleFrequencyChange &&
        (await handleFrequencyChange(
          data,
          value,
          quantity,
          isOnetime,
          convertToSub
        ))
      )
    }
  }

  // To show / hide modal for otp to sub
  toggleSingleSubscribeProductModal = () => {
    this.showSingleProductModal = !this.showSingleProductModal
  }

  // To show modal for otp to sub
  openSingleSubscribeProductModal = async subscription => {
    // Get product details to show in the modal
    const response = await catalogContainer.getProduct({
      productId: this.props?.data?.itemInfo?.[0]?.skus?.[0]?.id,
    })
    this.productType = this.props?.data?.type || ''
    // If the product is bundle / kit
    if (this.props?.bundleItems?.isBundle) {
      this.selectedProductDetails = {
        ...(response?.product?.[0] || {}),
        ...(response?.product?.[0]?.properties || {}),
        productId: response?.product?.[0]?.identifier || '',
        categoryId: response?.category?.identifier || '',
        quantity: this.props?.data?.itemInfo?.[0]?.quantity || 1,
        subscription: {
          frequencyPeriod: subscription?.frequencyPeriod,
          frequencyType: 'MONTHS',
        },
        isBundle: true,
        isFromDashboard: true,
      }
    } else {
      // If the product is single product
      this.selectedProductDetails = {
        ...(response?.product?.[0] || {}),
        ...(response?.product?.[0]?.properties || {}),
        transactionPrice: response?.product?.[0]?.prices?.[0] || {},
        skuId: this.props?.data?.itemInfo?.[0]?.skus?.[0]?.id || '',
        skuDetails: response?.product?.[0]?.selectedSku?.properties || {},
        quantity: this.props?.data?.itemInfo?.[0]?.quantity || 1,
        ...(response?.product?.[0].selectedSku?.properties || {}),
        subscription: {
          frequencyPeriod: subscription?.frequencyPeriod,
          frequencyType: 'MONTHS',
        },
        isFromDashboard: true,
      }
    }

    this.toggleSingleSubscribeProductModal()
  }
  handleQuantityChange = async count => {
    const { handleQuantityChange, data } = this.props
    return handleQuantityChange && (await handleQuantityChange(data, count))
  }
  renderFrequencyView = () => {
    const {
      frequencyPeriod,
      frequencyType,
      /*itemInfo  , currencySign */
      type,
    } = this.props?.data
    const { disableActions = false } = this.props
    const isGift = this.props.data?.itemInfo?.[0].properties?.isGiftItem || ''
    /*const frequencyOptionList = getFrequencyList(itemInfo[0].properties)
    const selectedFrequencyValue = [frequencyPeriod, frequencyType].join('-')
    const selectedFrequency = frequencyOptionList.findIndex(
      frequencyOption => frequencyOption.value === selectedFrequencyValue
    )*/

    return (
      <div className="font-weight-bold frequency-wrapper frequency-width">
        <div
          className={` align-items-center ${
            this.disableNonActiveMonth && 'disabled'
          }`}>
          <SubscriptionDropDown
            disableActions={disableActions}
            frequencyPeriod={frequencyPeriod}
            frequencyType={frequencyType}
            itemId={0}
            quantity={0}
            isGift={isGift}
            handleSubscriptionChange={this.handleFrequencyChange}
            isSubscriptionPage={this.isSubscriptionPage}
            isProductStatusInactive={this.props?.isProductStatusInactive}
            isDataFromSubModal={true}
            orderType={type}
          />
          {/*
            <div className="d-flex frequency-title align-items-center text-uppercase pr-2">
              <Trans i18nKey="subscriptionProdTile.frequency">
                Frequency:{' '}
              </Trans>
            </div>
            <div>
            <FrequencyDropdown
              customItemClass={'d-flex'}
              frequencyOptionList={frequencyOptionList}
              selectedFrequency={selectedFrequency > -1 ? selectedFrequency : 0}
              onChange={this.handleFrequencyChange}
              itemInfo={itemInfo}
              isToShowSmallText={
                application.isMobile || application.isTablet
                  ? !this.isToShowSmallText
                  : this.isToShowSmallText
              }
              transFrequency="subscriptionProdTile"
            />
            </div>*/}
        </div>
      </div>
    )
  }
  renderQuantity = () => {
    const id = this.props?.data?.id || 1
    const quantity = this.props?.data?.itemInfo?.[0]?.quantity || 1
    const maxpurchasequantity =
      this.props?.data?.itemInfo?.[0]?.properties?.maxpurchasequantity || 5
    const { disableActions = false, isProductStatusInactive = false } =
      this.props
    const productInfo = this.props?.data?.itemInfo?.[0]?.properties || {}
    const isGift = this.props?.data?.itemInfo?.[0].properties?.isGiftItem || ''
    const availableToCSR = productInfo?.availabletocsr || ''
    const availableToStoreFront = convertToBoolean(
      productInfo?.availabletostorefront || true
    )
    const availableInStore = productInfo?.availableinstore || ''
    return (
      <div className={`cart-quantity-wrapper p-0`}>
        <div
          className={` justify-content-lg-end justify-content-md-end align-items-center
          ${this.disableNonActiveMonth && 'disabled'}`}>
          <div className="p-0 subs-cart-quantity">
            <div
              className={`Dropdown-wrapper w-103 ${
                availableToCSR > 0 &&
                !availableToStoreFront &&
                availableInStore !== '6' &&
                'disabled'
              }`}>
              <SubscriptionQuantityDropdown
                quantity={quantity}
                className="p-0"
                cartItemId={id}
                maxCartItemLimit={maxpurchasequantity}
                handleCartQuantityChange={this.handleQuantityChange}
                transCart="viewCart"
                isGift={isGift}
                isPVAssistant={this.props.isPvAssistantPage}
                disableActions={disableActions}
                isProductStatusInactive={isProductStatusInactive}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
  handleRemoveDisableCondition = () => {
    this.isDeleteCallInProgress = false
  }

  handleSkipDisableCondition = () => {
    this.isSkipCallInProgress = false
  }

  handleConfirmation = () => {
    if (this.skipConfirmation) {
      const { handleSkipItem, data } = this.props
      data.isSkippedSubscription = this.isSkippedSubscription
      this.isSkipCallInProgress = true
      let isSkipped = this.props?.data?.properties?.isSkipped || false
      const { price } = data?.itemInfo?.[0] || {}
      const { name, id } = data?.itemInfo?.[0]?.skus?.[0] || {}
      /**
       * @info
       * GTM Datalayer- for skip button in subscription Dashboard
       * triggers on click of the skip button
       */
      if (isSkipped === 'false') {
        TagManager.dataLayer({
          dataLayer: {
            event: 'skipSubscription',
            pagePath: pageNames.myaccountsubscriptions,
            pageTitle: 'subscriptions',
            isSkippedSubscription: this.isSkippedSubscription,
            subscriptionID: id,
            productName: name,
            price: price,
            firstDeliveryDate: data?.firstDeliveryDate,
            nextDeliveryDate: data?.nextDeliveryDate,
            platform: 'equinox',
          },
        })
      }
      handleSkipItem && handleSkipItem(data, this.handleSkipDisableCondition)
    } else if (this.cancelConfirmation) {
      const { handleCancelItem, data } = this.props
      this.isDeleteCallInProgress = true
      const { price } = data?.itemInfo?.[0] || {}
      const { name, id } = data?.itemInfo?.[0]?.skus?.[0] || {}

      /**
       * @info
       * GTM Datalayer- for deleting subscription item
       * triggers on click of the item level delete icon in subscription dashboard
       */

      TagManager.dataLayer({
        dataLayer: {
          event: 'deletedSubscriptionItem',
          pagePath: pageNames.myaccountsubscriptions,
          pageTitle: 'subscriptions',
          isDeleteCallInProgress: this.isDeleteCallInProgress,
          subscriptionID: id,
          productName: name,
          price: price,
          platform: 'equinox',
        },
      })
      handleCancelItem &&
        handleCancelItem(data, this.handleRemoveDisableCondition)
    } else if (this.removeItemSubscription) {
      const { handleItemProcessing, data } = this.props
      handleItemProcessing &&
        handleItemProcessing(data, this.handleSkipDisableCondition)
    }
    this.skipConfirmation = false
    this.cancelConfirmation = false
    this.enableConfirmation = false
    this.removeItemSubscription = false
  }

  handleSkipItem = () => {
    const { data } = this.props
    const { name, id } = data?.itemInfo?.[0]?.skus?.[0] || {}
    let remainArray =
      subscriptionContainer.selectedSubscription?.filter(
        subscriptionData =>
          subscriptionData?.id !== data?.id &&
          subscriptionData?.properties?.isSkipped !== 'true'
      ) || []
    let hasOneTime =
      remainArray.some(data => data?.type === 'VARIABLE_SINGLE_ORDER') || false
    let hasMultiTime =
      remainArray.some(data => data?.type === 'VARIABLE_MULTI_ORDER') || false
    if (hasMultiTime || remainArray.length === 0) {
      this.skipConfirmation = true
      this.isSkippedSubscription = true
      this.enableConfirmation = true
      /**
       * @info
       * GTM Datalayer that tracks if the skip modal is open or not
       * triggers on click of the skip button in subscription card
       */

      TagManager.dataLayer({
        dataLayer: {
          event: 'skipModalIsOpen',
          pagePath: pageNames.myaccountsubscriptions,
          pageTitle: 'subscriptions',
          subscriptionID: id,
          productName: name,
          platform: 'equinox',
        },
      })
    } else if (hasOneTime && !hasMultiTime) {
      this.isInfoModalEnabled = true
      this.skipConfirmation = true
    }
  }

  handleUnSkipItem = () => {
    this.skipConfirmation = true
    this.isSkippedSubscription = false
    this.enableConfirmation = true
    const { data } = this.props
    const { price } = data?.itemInfo?.[0] || {}
    const { name, id } = data?.itemInfo?.[0]?.skus?.[0] || {}

    /**
     * @info
     * GTM Datalayer - for unskip button in subscription Dashboard
     * triggers on click of the unskip button
     */

    TagManager.dataLayer({
      dataLayer: {
        event: 'unskipSubscription',
        pagePath: pageNames.myaccountsubscriptions,
        pageTitle: 'subscriptions',
        isSkippedSubscription: this.isSkippedSubscription,
        subscriptionID: id,
        productName: name,
        price: price,
        firstDeliveryDate: data?.firstDeliveryDate,
        nextDeliveryDate: data?.nextDeliveryDate,
        platform: 'equinox',
      },
    })
  }

  handleItemProcessing = () => {
    this.removeItemSubscription = true
  }
  deleteToggleQuickView = () => {
    this.isInfoModalEnabled = false
    this.skipConfirmation = false
  }
  renderScanInfoModal = () => {
    const tittle = this.skipConfirmation
      ? i18nTranslate('subscription.skip', 'Unable to Skip items')
      : i18nTranslate('subscription.delete', 'Unable to Delete items')
    return (
      <>
        <Modal
          centered={true}
          show={this.isInfoModalEnabled}
          className="subscription-dialog"
          dialogClassName="quick-view-dialog"
          onHide={this.deleteToggleQuickView}>
          <Modal.Header className="border-0" closeButton>
            <ModalTitle
              className="font-weight-bold d-flex m-0"
              data-testid="qa-subscription-Unable-process">
              <InformationIcon size="1.5rem" className="mr-2" />
              {tittle}
            </ModalTitle>
          </Modal.Header>
          <Modal.Body>
            {i18nTranslate(
              'subscription.deleteDetails',
              'At least one subscription item must ship with one time items. To delete subscription items, please remove one-time items from your next shipment.'
            )}
          </Modal.Body>
        </Modal>
      </>
    )
  }
  handleCancelItem = () => {
    const { data } = this.props
    const { name, id } = data?.itemInfo?.[0]?.skus?.[0] || {}
    let remainArray =
      subscriptionContainer.selectedSubscription?.filter(
        subscriptionData => subscriptionData?.id !== data?.id
      ) || []
    let hasOneTime =
      remainArray.some(data => data?.type === 'VARIABLE_SINGLE_ORDER') || false
    let hasMultiTime =
      remainArray.some(data => data?.type === 'VARIABLE_MULTI_ORDER') || false
    if (hasMultiTime || remainArray.length === 0) {
      this.cancelConfirmation = true
      this.enableConfirmation = true
      /**
       * @info
       * GTM Datalayer that tracks if the delete modal is open or not
       * triggers on click of the delete icon in subscription card
       */

      TagManager.dataLayer({
        dataLayer: {
          event: 'deleteModalIsOpen',
          pagePath: pageNames.myaccountsubscriptions,
          pageTitle: 'subscriptions',
          subscriptionID: id,
          productName: name,
          platform: 'equinox',
        },
      })
    } else if (hasOneTime && !hasMultiTime) {
      this.isInfoModalEnabled = true
    }
  }
  renderSkipConfirmation = () => {
    let isSkipped = this.props?.data?.properties?.isSkipped || false
    if (isSkipped === true || isSkipped === 'true') {
      isSkipped = true
    } else {
      isSkipped = false
    }
    return (
      <>
        <p className="text-danger m-0 d-flex justify-content-start">
          {this.skipConfirmation
            ? isSkipped
              ? i18nTranslate(
                  'subscriptionProdTile.unskipConfirmation',
                  'UNSKIP?'
                )
              : i18nTranslate('subscriptionProdTile.skipConfirmation', 'SKIP?')
            : i18nTranslate('subscriptionProdTile.cancel', 'CANCEL?')}
        </p>
        <Button
          variant="transparent"
          className="skip-button rounded-0 confirmation-button text-uppercase"
          onClick={this.handleConfirmation}>
          {i18nTranslate('subscriptionProdTile.yes', 'YES')}
        </Button>
        <span className="separater">|</span>
        <Button
          variant="transparent"
          className="skip-button rounded-0 trash-button pr-0 pl-3"
          onClick={() => {
            this.skipConfirmation = false
            this.cancelConfirmation = false
            this.enableConfirmation = false
          }}>
          {i18nTranslate('subscriptionProdTile.no', 'NO')}
        </Button>
      </>
    )
  }
  renderSkipButton = () => {
    const isGift = this.props?.data?.itemInfo?.[0]?.properties?.isGiftItem || ''
    let isSkipped = this.props?.data?.properties?.isSkipped || false
    if (isSkipped === true || isSkipped === 'true') {
      isSkipped = true
    } else {
      isSkipped = false
    }
    const { isProductStatusInactive = false, disableActions = false } =
      this.props
    if (isSkipped) {
      return (
        <>
          <Button
            variant="transparent"
            className={`${
              isProductStatusInactive ? 'disabled' : ''
            } skip-button rounded-0 text-uppercase primary-button ${
              this.disableNonActiveMonth && 'disabled'
            }`}
            onClick={this.handleUnSkipItem}
            data-testid="qa-user-sub-product-skip"
            disabled={this.isSkipCallInProgress || disableActions || isGift}>
            {i18nTranslate('subscription.unSkipText', 'Un Skip')}
          </Button>
        </>
      )
    } else {
      return (
        <>
          <Button
            variant="transparent"
            className={`${
              isProductStatusInactive ? 'disabled' : ''
            } skip-button rounded-0 text-uppercase primary-button ${
              this.disableNonActiveMonth && 'disabled'
            }`}
            onClick={this.handleSkipItem}
            data-testid="qa-user-sub-product-skip"
            disabled={this.isSkipCallInProgress || disableActions || isGift}>
            <span className="skip_button">
              {i18nTranslate('subscription.skipText', 'Skip')}
            </span>
          </Button>
        </>
      )
    }
  }
  handleCancelOperation = () => {
    this.skipConfirmation = false
    this.cancelConfirmation = false
    this.enableConfirmation = false
    this.removeItemSubscription = false
  }

  handleScan = (productInfo = {}, bundle = false, bundleScanCount = 0) => {
    this.scanCardShow = true
    this.scanCardProductDetails = productInfo
    this.bundleScan = bundle
    this.bundleScanCount = bundleScanCount
  }

  toggleQuickView = () => {
    this.scanCardShow = false
  }

  renderScanCardBtn = (
    productInfo,
    bundle = false,
    disabled = false,
    frequencyOrderType
  ) => {
    let scanCount = 0

    if (bundle) {
      const skus = this.props?.data?.itemInfo?.[0]?.skus || []
      scanCount = getScanQualifiedCountSumForBundleSubItems(skus)
    } else {
      scanCount = productInfo?.scanQualifiedCount || 0
    }
    return (
      scanCount > 0 &&
      frequencyOrderType === 'VARIABLE_MULTI_ORDER' && (
        <div
          className="d-flex justify-content-center mt-3 text-uppercase"
          data-testid="qa-ScanCard">
          <Button
            className="scan-card-btn"
            disabled={disabled}
            onClick={() => {
              this.handleScan(productInfo, bundle, scanCount)
            }}>
            {i18nTranslate('cart.scanCard', 'Scan Card')}
          </Button>
        </div>
      )
    )
  }

  renderCartPromotions = (promoBreakup = [], pdtName = '') => {
    if (promoBreakup?.length > 0) {
      return promoBreakup.map((promotion, index) => {
        const displayMessage = promotion?.displayMessage || ''
        const message = promotion?.message || displayMessage || ''
        return <div key={index}>{message}</div>
      })
    } else {
      return pdtName ? <div>{pdtName}</div> : <></>
    }
  }

  renderPromotionsToolTip = (promotionArray = [], productName = '') => {
    /* to display cartLevelPromotions as tooltip*/
    if (promotionArray?.length || productName) {
      const promotionsView = this.renderCartPromotions(
        promotionArray,
        productName
      )
      return (
        <OverlayTrigger
          delay={{ show: 100, hide: 250 }}
          overlay={
            <div className="promotions-tooltip promotion-tooltip-message">
              {promotionsView}
            </div>
          }>
          <InformationIcon className="subs-promotions-tooltip" />
        </OverlayTrigger>
      )
    }
    return <></>
  }
  getItemLink = linkOptions => {
    const { data = {} } = this.props || {}
    const { items = [], isBundle = false, bundle = {} } = linkOptions || {}
    const productSlug = items?.itemInfo?.[0]?.properties?.slug || ''
    let skuVariant = data?.properties?.slug || ''
    const variantLabel =
      data?.properties?.variantLabel ||
      items?.itemInfo?.[0]?.skus?.[0]?.skuProperties?.variantLabel
    if (!skuVariant) {
      skuVariant = items?.itemInfo?.[0]?.skus?.[0]?.skuProperties?.slug || ''
    }

    const productID = isBundle
      ? bundle?.productId
      : this.props?.data?.itemInfo?.[0]?.skus?.[0]?.productId

    const productOrSlugId = productSlug ? productSlug : productID
    const categoryId = data?.properties?.categoryId || ''
    let productQueryParams = new URLSearchParams()

    if (variantLabel) {
      const slugVariant =
        items?.itemInfo?.[0]?.skus?.[0]?.skuProperties?.slug ||
        items?.itemInfo?.[0]?.skus?.[0]?.id
      productQueryParams.append('variant', slugVariant)
    }
    productQueryParams = productQueryParams.toString()
    const url =
      `${pageNames.product}/${productOrSlugId}` +
      (productQueryParams ? `?${productQueryParams}` : '')
    return url
  }
  renderProductDetails(
    items,
    productInfo,
    productID,
    bundle,
    isBundle,
    frequencyOrderType
  ) {
    // const { selectedMonth, lastOrderProcessedMonth, currentMonth } = this.props
    const {
      isStockError = false,
      isProductStatusInactive = false,
      disableActions = false,
      data = {},
    } = this.props
    let isDiscontinued = false
    if (
      isProductStatusInactive &&
      productInfo?.productStatus?.toLowerCase?.() === 'discontinued'
    ) {
      isDiscontinued = true
    }
    const customClass =
      isStockError || isProductStatusInactive ? 'disabled' : ''
    const skuID =
      (isBundle ? bundle.id : items?.itemInfo?.[0]?.skus?.[0]?.id) || ''

    const url = this.getItemLink({ items, isBundle, bundle })

    // const url = categoryId
    //   ? `${pageNames.product}/${productOrSlugId}?categoryId=${categoryId}`
    //   : `${pageNames.product}/${productOrSlugId}`
    /**
     * @note
     * As per BA's Comments, showing itemInfo.price node for Bundle/Kit products
     */
    const transactionPrice = items?.itemInfo?.[0]?.price || ''
    // ? get(bundle, 'skuProperties.', '')
    // : get(items, 'itemInfo.0.price', '') || ''
    const totalValue = items?.itemInfo?.[0]?.totalValue || {}
    const { originalPrice = '', priceAfterDiscount = '' } = totalValue

    const { currencySign } = this.props
    const priceObj = {
      currencySymbol: currencySign,
      price: parseFloat(originalPrice),
      discountedPrice: parseFloat(priceAfterDiscount),
      totalValue,
      // originalPrice: parseFloat(totalValue?.originalPrice),
      // priceAfterDiscount: parseFloat(totalValue?.priceAfterDiscount),
    }
    let isSkipped = this.props?.data?.properties?.isSkipped || false

    if (isSkipped === true || isSkipped === 'true') {
      isSkipped = true
    } else {
      isSkipped = false
    }
    const availableToCSR = productInfo?.availabletocsr || ''
    const availableToStoreFront = convertToBoolean(
      productInfo?.availabletostorefront || true
    )
    const availableInStore = productInfo?.availableinstore || ''
    const pvValue = items?.properties?.pointValue || '00.00'
    const isStarterKit = productInfo?.isstarterkit || 'false'
    const partNumber = productInfo?.partnumber || ''
    const variant = productInfo?.variant || ''
    const quantity = this.props?.data?.itemInfo?.[0]?.quantity || 1
    const productAddedText = i18nTranslate(
      'subscription.productAddedText',
      'Added Successfully'
    )
    const promotionArray =
      this.props?.data?.itemInfo?.[0]?.promotions?.[0]?.breakup || ''

    let productInfo_gift =
      this.props?.data?.itemInfo?.[0]?.skus?.[0]?.skuProperties || ''

    const giftImage =
      productInfo_gift?.skuProperties?.primaryimage ||
      productInfo_gift?.skuProperties?.imageURL
    const isGift = this.props.data?.itemInfo?.[0]?.gifts?.length > 0
    let freeGiftsData = isGift ? this.props.data?.itemInfo?.[0]?.gifts : []

    const fullproductName = items?.itemInfo?.[0]?.skus?.[0]?.name || ''
    const productName = fullproductName
    const popover =
      subscriptionContainer.renderFreeGiftSubscriptionPopover(freeGiftsData)
    let accounts = customerContainer.profileResponse?.accounts || {}
    let accountType = accounts?.type || ''
    const isToShowPVCVSV = isEligibleToShowPVCVSV({
      accountType,
      gateBrandAffiliate: false,
    })
    const priceFacets =
      this.props?.data?.itemInfo?.[0]?.totalValue?.priceFacets || {}
    const pvPrice = priceFacets?.PV?.PVAfterDiscount || ''
    const disableScanCardBtn =
      customClass === 'disabled' || isSkipped ? true : false
    let isOneTimeSub =
      this.props.data?.type === 'VARIABLE_SINGLE_ORDER' || false

    return (
      <>
        <div
          className={`prod-desc-left  ${customClass} ${
            (isSkipped ||
              (availableToCSR > 0 &&
                availableInStore !== '6' &&
                !availableToStoreFront)) &&
            'disabled'
          }`}>
          <div className="product-name-price">
            <div>
              <OverlayTrigger
                placement="top"
                delay={{ show: 100, hide: 250 }}
                overlay={
                  <Tooltip className="overlay-content" variant="success">
                    {fullproductName}
                  </Tooltip>
                }>
                <div>
                  <LinkWithLocale
                    to={{
                      pathname: url,
                    }}
                    className={`text-decoration-none prod-desc-title text-capitalize paragraph-m`}
                    data-testid="qa-user-sub-product-name">
                    {/* <p
                    className="prod-desc-title text-capitalize paragraph-m"
                    data-testid="qa-user-sub-product-name">
                    {`${isBundle ? bundle?.name : productName}${variant &&
                      ' - ' + variant}`}
                  </p> */}
                    {`${isBundle ? bundle?.name : productName}${
                      variant && ' - ' + variant
                    }`}
                  </LinkWithLocale>
                </div>
              </OverlayTrigger>
              {!isBundle && skuID != '' && (
                <h6 className="itemno heading-5">
                  {i18nTranslate('subscription.itemcode', 'Item')} #{' '}
                  <span>{skuID}</span>
                </h6>
              )}
            </div>
            {isGift && (
              <div className="gift_card">
                {i18nTranslate(
                  'subscriptionProdTile.giftIncluded',
                  'Free Gift Included'
                )}{' '}
                <OverlayTrigger
                  trigger="click"
                  placement="top"
                  rootClose={true}
                  overlay={popover}>
                  <InformationIcon size="1.5rem" className="giftInfo ml-2" />
                </OverlayTrigger>
              </div>
            )}
            {/* <SubscriptionsProductPrice {...totalValue} isSubscription={true} /> */}
            <div className="d-flex w-100">
              <PriceSubscription
                classStyles={`d-flex align-items-center flex-row justify-content-lg-end mb-2`}
                transactionPrice={priceObj}
                isStarterKit={isStarterKit}
                partNumber={partNumber}
              />
              {/* <div className="ml-2">
                {this.renderPromotionsToolTip(promotionArray, fullproductName)}
              </div> */}
            </div>
            {isToShowPVCVSV && (
              <Row
                noGutters
                className="product-ProductPrice pv-price d-flex w-100"
                data-testid="qa-product-price">
                <CustomPrice
                  custompriceValue={pvPrice}
                  custompriceLabel={i18nTranslate('subscription.svprice', 'SV')}
                  dataTestId="qa-subs-pvprice"
                />
              </Row>
            )}
          </div>

          <div className="d-flex flex-row justify-content-center prod-det-dropdown mt-2">
            {isStockError || disableActions || isProductStatusInactive ? (
              <div className="w-100">
                <div className="d-flex d-md-block flex-column">
                  <div
                    className="unavailable-item-text-with-border mb-2"
                    style={{
                      whiteSpace: this.props.isPvAssistantPage ? 'nowrap' : '',
                    }}>
                    {isStockError || disableActions
                      ? i18nTranslate('subscription.outOfStock', 'Out of Stock')
                      : isProductStatusInactive
                        ? isDiscontinued
                          ? i18nTranslate(
                              'Subscription.Discontinued',
                              'Discontinued'
                            )
                          : i18nTranslate(
                              'subscriptions.productStatusInactive',
                              'INACTIVE PRODUCT'
                            )
                        : i18nTranslate(
                            'subscription.unavailable',
                            'Unavailable'
                          )}
                  </div>

                  <div className="d-flex flex-row justify-content-center">
                    <div> {this.renderQuantity()}</div>
                    {!this.props.isPvAssistantPage && (
                      <div className="position-relative w-100 disable-frequency">
                        {this.renderFrequencyView()}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className="d-flex flex-row text-center">
                  <div> {this.renderQuantity()}</div>
                </div>
                {!this.props.isPvAssistantPage && (
                  <div className="frequency-change">
                    {this.renderFrequencyView()}
                  </div>
                )}
              </>
            )}
          </div>
        </div>

        <div className="prod-desc-right text-right d-flex flex-column justify-content-between">
          {isOneTimeSub && (
            <div className="sub-onetime-label">
              {i18nTranslate('subscription.oneTime', 'One-time')}{' '}
              {i18nTranslate('item', 'Item')}
            </div>
          )}
          {!(
            isStockError ||
            isProductStatusInactive ||
            this.props.isPvAssistantPage ||
            isOneTimeSub
          ) && (
            <div
              className={`action-button d-flex justify-content-center align-items-center`}>
              {/* {this.enableConfirmation
                ? this.renderSkipConfirmation()
                : this.renderSkipButton()} */}
              {!this.enableConfirmation && this.renderSkipButton()}
            </div>
          )}
        </div>

        {this.renderScanCardBtn(
          productInfo,
          isBundle,
          disableScanCardBtn,
          frequencyOrderType
        )}
        {this.props.isProductAddedInSubscriptionScreen && (
          <div
            className={`action-button mt-1 d-flex justify-content-center align-items-center`}>
            <label className="add-label-success-msg mb-0">
              {productAddedText}
            </label>
            <span className="success-tick-showall ml-1">
              <Icons
                name="CRUD"
                icontype="circled-tick"
                className="subscription-add-icon"
                width="16px"
                color="#3e7957"
              />
            </span>
          </div>
        )}
      </>
    )
  }
  handleProductSelectCheckbox = (id, pv) => {
    const { handleProductDelete } = this.props
    handleProductDelete && handleProductDelete(id, pv)
  }

  renderBundleProducts(productInfo) {
    const image =
      productInfo?.skuProperties?.primaryimage ||
      productInfo?.skuProperties?.imageURL

    const variant = productInfo?.variant || ''
    const {
      isStockError = false,
      isProductStatusInactive = false,
      isToDisableDeleteCheckbox = false,
    } = this.props
    const availableInStore = productInfo?.availableinstore || ''

    const items = this.props?.data || {}
    const pvValue = items?.properties?.pointValue || '00.00'
    const name = productInfo?.name || ''
    const size = productInfo?.skuProperties?.size || 1
    const quantity = productInfo?.skuQuantity || 1
    const id = productInfo?.id || 1
    const productID = productInfo?.productId || ''
    const url = productID ? `${pageNames.product}/${productID}` : ''
    const inventory = productInfo?.inventory || ''
    // const availableToStoreFront = convertToBoolean(
    //   productInfo?.availabletostorefront || 'true'
    // )

    return (
      <Row className="prod-desc-wrapper d-flex w-100 justify-content-center bundle-product-tile-container">
        <Col lg={2} />
        <Col lg={3} className="subitem">
          <LinkWithLocale
            to={{
              pathname: url,
            }}
            className={`prod-image-wrapper w-100 h-100`}>
            <ImageComponent
              width="120px"
              height="200px"
              optimizeImage={true}
              src={image || imagePlaceholder}
              alt={name}
              className={`mw-100 mh-100 prod-img`}
              data-testid="qa-user-sub-product-image"
            />
          </LinkWithLocale>
        </Col>
        <Col lg={7} className="product-align">
          <div className={`prod-desc-left`}>
            <LinkWithLocale
              to={{
                pathname: url,
              }}
              className={`text-decoration-none`}>
              <h3
                className="prod-desc-title text-capitalize"
                data-testid="qa-user-sub-product-name">
                {`${name || variant}`}
              </h3>
            </LinkWithLocale>
            <p className="mb-0 text-capitalize">
              {i18nTranslate('subscription.itemcode', 'item')} # {id}
            </p>
            <p className="mb-0">
              {i18nTranslate('subscription.bundleSubItemsQty', 'Qty:')}{' '}
              {quantity}
            </p>
            {size && (
              <p className="mb-0">
                {i18nTranslate('subscription.bundleSubItemsSize', 'Size:')}{' '}
                {size}
              </p>
            )}

            {inventory?.toLowerCase() === 'out of stock' && (
              <div className="unavailable-item-text-with-border mb-2">
                {i18nTranslate('subscription.outOfStock', 'Out of Stock')}
              </div>
            )}
            {/* CX121-4017 - BA action item, Storefront UI:enable the scan card option at KIT/Bundle header instead of component level.
            {this.renderScanCardBtn(productInfo, true)} */}
            {/* <div className="code-pv-wrap d-flex">
              <p
                className="prod-desc-code-pv mr-1 mb-0 d-none"
                data-testid="qa-user-sub-product-pv-value">
                <Trans i18nKey="subscriptionProdTile.pvValue">PV: </Trans>
                <p className="code-pv-value mb-0 d-none">{pvValue}</p>
              </p>
            </div> */}
          </div>
          {/* For bundle section availableToStoreFront is commented as it's not available, verified with BE team */}
          {/* {(isStockError ||
            isProductStatusInactive ||
            availableInStore === '3' ||
            availableInStore === '5') &&
            !availableToStoreFront && (
              <div
                className="out-of-stock position-relative w-100 text-center text-uppercase"
                style={{
                  whiteSpace: this.props.isPvAssistantPage ? 'nowrap' : '',
                }}>
                {i18nTranslate('subscriptions.outofstock', 'Out Of Stock')}
              </div>
            )} */}
        </Col>
      </Row>
    )
  }

  renderShippingAddress = (address = {}, isFromModal = false) => {
    const {
      addressLine1 = '',
      addressLine2 = '',
      street1 = '',
      street2 = '',
      city = '',
      state = '',
      zipCode = '',
      zip = '',
      // phone = '',
      country = '',
    } = address
    const actualZip = zipCode || zip
    return (
      <>
        <Col
          className="pr-3 pl-3 m-1 border-left border-right subscription-shipping-addr"
          data-testid="qa-user-sub-shipping-address">
          <Row noGutters className={'align-items-center'}>
            <Col className="col-10 text-uppercase shipping-text">
              {i18nTranslate('subscription.shippingTitle', 'Shipping Address')}
            </Col>
          </Row>
          <p className="subscription-shipping-address">
            {addressLine1 +
              addressLine2 +
              street1 +
              street2 +
              ' ' +
              city +
              ', ' +
              state +
              ', ' +
              actualZip}
            <br />
            {country}
          </p>
        </Col>
      </>
    )
  }
  renderPaymentMethod = (payment = {}, isFromModal = false) => {
    const {
      name = '',
      firstName = '',
      lastName = '',
      cardExpirationYear = '',
      cardExpirationMonth = '',
      expiryYear = '',
      expiryMonth = '',
      paymentType: type = '',
      displayName = '',
      // properties = {},
    } = payment

    /*
     * Temporarily splitting card number into 4 per group
     * TODO: Need to split card number based on card type
     */
    const cardNumber = (payment?.cardNumber || '').replace(
      /^(.{4})(.{4})(.{4})(.*)$/,
      '$1-$2-$3-$4'
    )
    const defaultSelectedMonth =
      subscriptionContainer?.subscriptionPreferenceResponse
        ?.selectedSubscriptions?.[0]?.selectedMonth || 0

    const month = this.props?.location?.queryParams?.month || ''
    let selectedMonth = 0
    const lastOrderProcessingDate =
      subscriptionContainer?.subscriptionPreferenceResponse
        ?.lastOrderProcessingDate || 0
    const lastOrderProcessedMonth =
      new Date(lastOrderProcessingDate).getMonth() + 1
    const lastSubscriptionOrderStatus =
      subscriptionContainer?.subscriptionPreferenceResponse?.lastOrderStatus ||
      ''

    if (subscriptionContainer.selectedMonth != '') {
      selectedMonth = subscriptionContainer.selectedMonth
    } else {
      selectedMonth = defaultSelectedMonth
    }
    const totalActiveSubscriptionCount =
      cartContainer?.subscriptionResponse
        ?.totalActiveSubscriptionItemQuantityCount || ''

    const accountNumber = payment?.properties?.accountNumber || ''
    const bankName = payment?.properties?.bankName || ''
    const endingDigits = accountNumber
      ? accountNumber.substr(accountNumber.length - 4)
      : undefined
    return (
      <>
        <Col
          className="p-1 pl-3 m-1 subscription-payment"
          data-testid="qa-user-sub-payment-method">
          {!isFromModal && (
            <Row noGutters className={'align-items-center'}>
              {lastOrderProcessedMonth == selectedMonth &&
                (lastSubscriptionOrderStatus.toLowerCase() ===
                  'payment_failed' ||
                  lastSubscriptionOrderStatus.toLowerCase() ===
                    'order_failed') &&
                totalActiveSubscriptionCount != 0 &&
                month !== 'showall' && (
                  <div className="col-1 warningIcnDiv">
                    <Icons
                      name="product-icon"
                      icontype="danger-warning"
                      className="subscription-wrn-icon"
                      color="#8C6E43"
                    />
                  </div>
                )}
              <Col className="col-9 text-uppercase shipping-text">
                {i18nTranslate('subscription.paymentTitle', 'Payment Method')}
              </Col>
            </Row>
          )}
          {type && type.toLowerCase() === 'ach' ? (
            <Col className="p-0 text-dark">
              {i18nTranslate('subscription.achPayment', 'ACH')}
              <br />
              {bankName}
              <br />
              {endingDigits && (
                <>{`${i18nTranslate(
                  'payment.accountEndingText',
                  'Account ending in'
                )} - ${endingDigits}`}</>
              )}
            </Col>
          ) : type && type.toLowerCase() === 'paypalsubscription' ? (
            <Col className="p-0 text-dark">
              {i18nTranslate(
                'subscription.paypalsubscription',
                'PayPal Account'
              )}
              <br />
              {displayName}
            </Col>
          ) : (
            type &&
            (type?.toLowerCase() === 'creditcard' ||
              type?.toLowerCase() === 'debitcard') && (
              <p className="p-0 text-dark">
                {name != null && `${firstName || name}`}
                {lastName != null && ` ${lastName}`}
                {name != null && lastName != null && <br />}
                {cardNumber}
                <br />
                {`${cardExpirationMonth || expiryMonth}/${
                  cardExpirationYear || expiryYear
                }`}
              </p>
            )
          )}
        </Col>
      </>
    )
  }
  renderShippingMethod = (shipping = {}, isFromModal = false) => {
    const shippingMethods = this.props?.shippingMethods || []
    const selectedShippingMethod = shippingMethods.filter(item => {
      {
        return item?.shippingMethodId == shipping.method
      }
    })
    const shippingMethod = selectedShippingMethod.length
      ? { ...selectedShippingMethod[0] }
      : shipping
    const { method = '', name = '', cost = '0' } = shippingMethod
    const currencySymbol = this.props?.currencySymbol || '$'
    let description = shippingMethod?.description || ''
    const getMonthlyPV =
      subscriptionContainer?.subscriptionPreferenceResponse?.order?.monthlyPV ||
      0

    const shippingCost =
      getMonthlyPV >= 100 &&
      (method.toLowerCase() == 'economy' || name.toLowerCase() == 'economy')
        ? i18nTranslate('subscription.free', 'FREE')
        : `${currencySymbol}${cost}`
    const displayDescription =
      description && description.toLowerCase() != 'none'
        ? `- (${description} business days)`
        : `- ${i18nTranslate('subscription.noItemsAdded', 'No Items Added')}`
    return (
      <>
        <Col
          className={`p-1 pl-3 m-1 subscription-shipping`}
          data-testid="qa-user-sub-shipping-method">
          {!isFromModal && (
            <Row noGutters className={'align-items-center'}>
              <Col className="col-10 text-uppercase shipping-text">
                {i18nTranslate(
                  'subscription.shippingMethod',
                  'Shipping Method'
                )}{' '}
              </Col>
            </Row>
          )}
          <Col className="p-0 text-dark">
            {method || name ? (
              <>
                {`${method || name} ${displayDescription} ${
                  cost ? shippingCost : ''
                }`}
              </>
            ) : (
              <>
                {i18nTranslate(
                  'subscription.shippingMethodDescription',
                  'No Shipment This Month'
                )}
              </>
            )}
          </Col>
        </Col>
      </>
    )
  }

  render() {
    const subscriptionCount = this.props?.totalSubscriptionCount || 0
    const orders = subscriptionContainer?.subscriptionPreferenceResponse?.order
    const itemId = this.props?.data?.id || '0'
    const shippingAddress =
      subscriptionContainer?.subscriptionPreferenceResponse?.addresses || ''

    const minMonthlyPV = orders?.monthlyPV || '0'
    const {
      isStockError = false,
      isProductStatusInactive = false,
      isToDisableDeleteCheckbox = false,
      data = {},
    } = this.props
    const customClass =
      isStockError || isProductStatusInactive ? 'disabled' : ''
    const items = this.props?.data || {}
    const frequencyOrderType = data?.type || 'VARIABLE_MULTI_ORDER'
    const pv = items?.properties?.pointValue || '00.00'
    const productName = items?.itemInfo?.[0]?.skus?.[0]?.name || ''

    const {
      bundle: [bundleItems = {}] = [],
      isBundle,
      optionalCount,
      mandatoryCount,
    } = this.props?.bundleItems || {}
    const _bundle = {
      ...bundleItems,
      ...(bundleItems?.skuProperties || {}),
    }
    //let productInfo = get(this.props, 'data.itemInfo.0.skus.0.skuProperties')
    let productInfo = isBundle
      ? _bundle
      : this.props?.data?.itemInfo?.[0]?.skus?.[0]?.skuProperties
    if (
      productInfo &&
      Object.keys(productInfo) &&
      Object.keys(productInfo).length == 0
    ) {
      productInfo =
        this.props?.data?.itemInfo?.[0]?.skus?.[0]?.skuProperties || ''
    }

    const productID = isBundle
      ? _bundle?.productId
      : this.props?.data?.itemInfo?.[0]?.skus?.[0]?.productId

    const availableToCSR = productInfo?.availabletocsr || ''
    const availableToStoreFront = convertToBoolean(
      productInfo?.availabletostorefront || 'true'
    )
    const url = this.getItemLink({ items, isBundle, bundle: _bundle })

    let isToSelectProduct = false
    if (subscriptionContainer.selectedSubscriptionProducts.has(itemId)) {
      isToSelectProduct = true
    }
    const productImage = getImageFromProperty(
      isBundle
        ? bundleItems?.skuProperties
        : items?.itemInfo?.[0]?.skus?.[0]?.skuProperties
    )
    let pvTitle = i18nTranslate('subscription.pvTitle', 'UNDER 50PV MINIMUM')

    let pvMessage = i18nTranslate(
      'subscription.pvMessage',
      'By deleting this item you will fall below the 50PV minimum and will not earn Nu Skin Rewards on this purchase. Would you like to proceed?'
    )

    let skipUnder = i18nTranslate(
      'subscription.skipUnder',
      'By skipping this item you will fall below the 50PV minimum and will not earn Nu Skin Rewards on this purchase. Would you like to proceed?'
    )

    let skipMessage = i18nTranslate(
      'subscription.skipMessage',
      'Clicking "Skip" below will result in the skipping of this item for this month.'
    )

    let skipSubscription = i18nTranslate(
      'subscription.skipLastSub',
      'By skipping this item you will be processing a skip for your subscription'
    )

    let skipLastSubTitle = i18nTranslate(
      'subscription.skipLastSubTitle',
      'Skip Entire Month?'
    )

    let isSkipped = this.props?.data?.properties?.isSkipped || false
    if (isSkipped === true || isSkipped === 'true') {
      isSkipped = true
      if (minMonthlyPV + parseFloat(pv) <= 50) {
        skipMessage = i18nTranslate(
          'subscription.unSkipMessage50pv',
          'Clicking "Un Skip" below will result in the Un skipping of this item for this month.'
        )
      } else {
        skipMessage = i18nTranslate(
          'subscription.unSkipMessage',
          'Clicking "Un Skip" below will result in the Un skipping of this item for this month.'
        )
      }
    } else {
      isSkipped = false
      skipMessage = i18nTranslate(
        'subscription.skipMessage',
        'Clicking "Skip" below will result in the skipping of this item for this month.'
      )
    }
    const enableItemLevelProcessing =
      this.props?.data?.enableItemLevelProcessing || false
    const addressInfo = this.props?.data?.addressInfo || {}
    const paymentInfo = this.props?.data?.paymentInfo || {}
    const shippingInfo = this.props?.data?.shippingInfo || {}
    const availableInStore = productInfo?.availableinstore || ''
    const isProps65Warning = convertToBoolean(
      this.props?.data?.itemInfo?.[0]?.properties?.isprop65 || 'false'
    )
    const shippingState = shippingAddress?.state || ''
    return (
      <>
        <div className="product-box">
          <Form.Check
            className={`subs-delete-product-checkbox`}
            custom
            id={`subscription-month-product-checkbox-${itemId}`}
            label={
              <span className="sr-only">
                {`${i18nTranslate(
                  'subscription.productCheckbox',
                  'Subscription Product Checkbox'
                )} ${productName}`}
              </span>
            }
            checked={isToSelectProduct}
            onChange={() => {
              this.handleProductSelectCheckbox(itemId, parseFloat(pv))
            }}
            disabled={isToDisableDeleteCheckbox}
          />
          <Button
            variant="transparent"
            className="text-right delete_button sub-tile-trash-icon"
            tabIndex="0"
            role="button"
            onClick={this.handleCancelItem}
            data-testid="qa-user-sub-product-cancel"
            disabled={this.isDeleteCallInProgress}>
            <Icons
              name="CRUD"
              icontype="delete"
              customicon="Delete"
              className="sub-product-delete-icon"
              width="20px"
              alt={i18nTranslate('subscription.trashIcon', 'trash icon')}
              ariaLabel={`${i18nTranslate(
                'migratedSubscription.delete',
                'Delete Subscription'
              )} ${productName}`}
              fill="#3a3a3a"
            />
          </Button>

          <div className="prod-tile-container minMaxSubProdTile">
            <div
              data-testid="qa-user-sub-products-container"
              className="d-flex flex-wrap"
              style={{
                borderRadius: this.props.isProductAddedInSubscriptionScreen
                  ? '4px'
                  : '',
                opacity: this.props.isProductAddedInSubscriptionScreen
                  ? '1'
                  : '',
                padding: this.props.isProductAddedInSubscriptionScreen
                  ? '5px'
                  : '',
              }}>
              <>
                {/* {!this.props.isPvAssistantPage &&
              (isStockError || isProductStatusInactive) ? (
                <div
                  className="d-flex w-100 subs-delete-product-checkbox delete-icon"
                  onClick={this.handleCancelItem}>
                  <Icons
                    name="CRUD"
                    icontype="delete"
                    customicon="Delete"
                    width="24px"
                    alt={i18nTranslate('subscription.trashIcon', 'trash icon')}
                    ariaLabel={`${i18nTranslate(
                      'migratedSubscription.delete',
                      'Delete Subscription'
                    )} ${productName}`}
                    fill="#3a3a3a"
                    data-testid="qa-subscription-month-dropdown"
                  />
                </div>
              ) : (
                <></>
              )} */}

                <div className="subs-prod-img m-auto">
                  <LinkWithLocale
                    to={{
                      pathname: url,
                    }}
                    className={`prod-image-wrapper w-100  ${
                      ((availableToCSR > 0 && availableInStore !== '6') ||
                        isStockError ||
                        isProductStatusInactive ||
                        isSkipped) &&
                      !availableToStoreFront &&
                      'disabled'
                    }`}>
                    <ImageComponent
                      width="200px"
                      height="auto"
                      optimizeImage={true}
                      src={productImage || imagePlaceholder}
                      alt={productInfo?.name}
                      className={`mw-100 mh-100 prod-img ${
                        isSkipped && 'disabled'
                      }`}
                      data-testid="qa-user-sub-product-image"
                    />
                    {(isStockError ||
                      isProductStatusInactive ||
                      availableInStore === '3' ||
                      availableInStore === '5') &&
                      !availableToStoreFront && (
                        <div
                          className="out-of-stock position-relative w-100 text-center text-uppercase"
                          style={{
                            whiteSpace: this.props.isPvAssistantPage
                              ? 'nowrap'
                              : '',
                          }}>
                          {i18nTranslate(
                            'subscriptions.outofstock',
                            'Out Of Stock'
                          )}
                        </div>
                      )}
                  </LinkWithLocale>
                </div>
                <div className="prod-desc-wrapper w-100 justify-content-between">
                  {this.renderProductDetails(
                    items,
                    productInfo,
                    productID,
                    _bundle,
                    isBundle,
                    frequencyOrderType
                  )}
                </div>
                {this.props.isPvAssistantPage && (
                  <div
                    className={`pv-items-ranking ml-3 flex-column justify-content-center ${customClass}`}>
                    <Button
                      variant="transparent"
                      className="ranking-icon shadow-none rounded-0 p-0 primary-button"
                      style={{ width: '19px' }}
                      onClick={() => {
                        this.props.renderUpDown(this.props.index, 'up')
                      }}
                      disabled={
                        this.props.itemPriority == 1 ||
                        this.props.isToDisableDeleteCheckbox
                      }>
                      <Icons
                        viewBox="0 0 28 25"
                        name={'CRUD'}
                        color="#707070"
                        icontype={'caretup'}
                        customicon={i18nTranslate(
                          'subscriptions.pvPriorityUp',
                          'Priority Up'
                        )}
                        width="28px"
                      />
                    </Button>
                    <span
                      style={{
                        fontSize: '14px',
                        fontFamily: 'GTWalsheimPro-Light',
                      }}>
                      #{this.props.itemPriority}
                    </span>
                    <Button
                      variant="transparent"
                      className="ranking-icon shadow-none rounded-0 p-0 primary-button"
                      style={{ width: '19px' }}
                      onClick={() => {
                        this.props.renderUpDown(this.props.index, 'down')
                      }}
                      disabled={
                        this.props.disable ||
                        this.props.isToDisableDeleteCheckbox
                      }>
                      <Icons
                        viewBox="0 0 28 25"
                        name={'CRUD'}
                        color="#707070"
                        icontype={'caretdown'}
                        customicon={i18nTranslate(
                          'subscriptions.pvPriorityDown',
                          'Priority Down'
                        )}
                        width="28px"
                      />
                    </Button>
                  </div>
                )}
                {/* Added component to display confirmation view */}
                {this.enableConfirmation && this.cancelConfirmation && (
                  <ConfirmationModal
                    showConfirmationModal={this.cancelConfirmation}
                    handleConfirm={this.handleConfirmation}
                    handleCancel={this.handleCancelOperation}
                    handleHide={this.handleCancelOperation}
                    modalMessage={
                      minMonthlyPV - pv == 0
                        ? undefined
                        : minMonthlyPV - pv < 50
                          ? pvMessage
                          : undefined
                    }
                    renderText={
                      minMonthlyPV - pv == 0
                        ? undefined
                        : minMonthlyPV - pv < 50
                          ? pvTitle
                          : undefined
                    }
                    totalSubscriptionLength={subscriptionCount}
                    isSubscriptionDelete={true}
                  />
                )}
                {this.enableConfirmation && this.skipConfirmation && (
                  <ConfirmationModal
                    showConfirmationModal={this.skipConfirmation}
                    handleConfirm={this.handleConfirmation}
                    handleCancel={this.handleCancelOperation}
                    handleHide={this.handleCancelOperation}
                    modalMessage={
                      (minMonthlyPV - pv == 0) & (subscriptionCount == 1)
                        ? skipSubscription
                        : (minMonthlyPV < 50) & (minMonthlyPV - pv == 0)
                          ? skipMessage
                          : minMonthlyPV - pv < 50 && this.isSkippedSubscription
                            ? skipUnder
                            : skipMessage
                    }
                    renderText={
                      (minMonthlyPV - pv == 0) & (subscriptionCount == 1)
                        ? skipLastSubTitle
                        : (minMonthlyPV < 50) & (minMonthlyPV - pv == 0)
                          ? undefined
                          : minMonthlyPV - pv < 50
                            ? pvTitle
                            : undefined
                    }
                    confirmButtonText={
                      isSkipped
                        ? i18nTranslate('subscription.unSkipText', 'Un Skip')
                        : i18nTranslate('subscription.skipText', 'Skip')
                    }
                    totalSubscriptionLength={subscriptionCount}
                  />
                )}
              </>
            </div>
            {isBundle && (
              <div
                className="d-flex w-100"
                data-testid="qa-user-bundle-items-container">
                <Row noGutters className="w-100">
                  <span className="ml-auto qa-count" data-testid="qa-count">
                    <div />
                  </span>
                  <AccordionBlock
                    className="mr-auto py-0"
                    textClass="text-primary"
                    title={i18nTranslate('subscription.subItems', 'Sub-Items')} //CX121-4791 - Google Translated
                    dataTestId="qa-cart-view"
                    iconClass="text-dark"
                    subItemsClass="pl-4"
                    isOutsideAccordion={true}>
                    {[...mandatoryCount, ...optionalCount].map(
                      this.renderBundleProducts.bind(this)
                    )}
                  </AccordionBlock>
                </Row>
              </div>
            )}
            {this.removeItemSubscription && (
              <ConfirmationModal
                showConfirmationModal={this.removeItemSubscription}
                handleConfirm={this.handleConfirmation}
                handleCancel={this.handleCancelOperation}
                handleHide={this.handleCancelOperation}
                modalMessage={`Removal will associate the Shipping Method/Shipping Address/Payment Method at Subscription level`}
                renderText={i18nTranslate(
                  'confirm.continueMessage',
                  'Do you want to continue ?'
                )} //CX121-4791 - Google Translate
                confirmButtonText={i18nTranslate('subscription.yes', 'YES')}
                cancelButtonText={i18nTranslate('subscription.no', 'NO')}
              />
            )}

            {enableItemLevelProcessing && (
              <Row
                noGutters
                className="d-flex flex-column ml-2 mr-2 shipping-container border position-relative">
                <Row noGutters className="pt-2 flex-column flex-md-row">
                  {this.renderPaymentMethod(paymentInfo)}
                  {this.renderShippingAddress(addressInfo)}
                  {this.renderShippingMethod(shippingInfo)}
                </Row>
                <Button
                  variant="transparent skip-button rounded-0 text-uppercase primary-button position-absolute"
                  onClick={this.handleItemProcessing}
                  data-testid="qa-user-sub-product-remove">
                  {i18nTranslate('subscriptionProdTile.remove', 'REMOVE')}
                </Button>
              </Row>
            )}
            {isProps65Warning && shippingState.toUpperCase() === 'CA' && (
              <div className="d-flex mt-3">
                <div className="pr-2">
                  <Icons
                    viewBox="0 0 28 25"
                    name="product-icon"
                    icontype="danger-warning-prop65"
                    width="28px"
                  />
                </div>
                <p className="mb-0">
                  <span className="pdp-warning">WARNING: </span>
                  {i18nTranslate(
                    'pdp.prop65warning1',
                    'This product can expose you to chemicals including lead, which are known to the State of California to cause cancer',
                    {
                      nameSpace: 'ssr-resource',
                    }
                  )}{' '}
                  <u>
                    {i18nTranslate(
                      'pdp.prop65warning2',
                      'and birth defects or other reproductive harm',
                      {
                        nameSpace: 'ssr-resource',
                      }
                    )}
                  </u>
                  .{' '}
                  {i18nTranslate(
                    'pdp.prop65warning3',
                    'For more information, go to',
                    {
                      nameSpace: 'ssr-resource',
                    }
                  )}{' '}
                  <Nav.Link
                    className="trackingUrl-link p-0"
                    role="link"
                    target="_blank"
                    href="https://www.P65Warnings.ca.gov/food">
                    {i18nTranslate(
                      'pdp.p65WarningsLink',
                      'www.P65Warnings.ca.gov/food',
                      {
                        nameSpace: 'ssr-resource',
                      }
                    )}
                  </Nav.Link>
                </p>
              </div>
            )}
          </div>
          {this.scanCardShow && (
            <CartScanCard
              isScanModalOpen={this.scanCardShow}
              toggleQuickView={this.toggleQuickView}
              productInfo={this.scanCardProductDetails}
              bundle={this.bundleScan}
              bundleScanCount={this.bundleScanCount}
              page="subscription"
              {...this.props}
            />
          )}
        </div>

        {/* Modal to convert one time order to subscription */}
        {this.showSingleProductModal && (
          <SingleProductSubscriptionModal
            product={this.selectedProductDetails}
            isSubscribedBefore={true}
            productType={this.productType}
            isSignedUser={true}
            onUserSubscribe={this.handleFrequencyChange}
            show={this.showSingleProductModal}
            onHide={this.toggleSingleSubscribeProductModal}
            enablePDPNavigation={true}
            isSubscriptionPage={this.isSubscriptionPage}
            toggleSingleSubscribeProductModal={
              this.toggleSingleSubscribeProductModal
            }
          />
        )}
        {this.isInfoModalEnabled && this.renderScanInfoModal()}
      </>
    )
  }
}

export default SubscriptionProductTile
export { SubscriptionProductTile }
